import AsyncCallHandler from '../common/AsyncCallHandler'
import ACTION_TYPES from './actionTypes'
import NEXUS_CONST from '../common/constants'
import { set, get } from '../common/utils'


export const fetchUserCluster = (dispatch, site) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_USER_CLUSTER, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_USER_CLUSTER, payload: res.data });
        });
}

export const addUserCluster = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.ADD_USER_CLUSTER, NEXUS_CONST.POST, data)
        .then(res => {
            //fetchUserCluster(dispatch, null)
            //dispatch({ type: ACTION_TYPES.ADD_USER_CLUSTER, payload: res.data });
        });
}

export const deleteUserCluster = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.DELETE_USER_CLUSTER, NEXUS_CONST.POST, data)
        .then(res => {
            fetchUserCluster(dispatch, null)
            //dispatch({ type: ACTION_TYPES.DELETE_USER_CLUSTER, payload: res.data });
        });
}

export const updateUserCluster = (dispatch) => {

    AsyncCallHandler(NEXUS_CONST.UPDATE_USER_CLUSTER, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.UPDATE_USER_CLUSTER, payload: res.data });
        });
}